import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import {
  PasswordSubmitMethod,
  PasswordSubmitMethodFormFields,
} from '~/scenes/PeopleModule/components/EmployeeActions/ResetPassword/PasswordSubmissionMethodForm/data';
import { isValidOptionalPhoneNumber } from '~/utils/helper';

export const usePasswordSubmitMethodValidationSchema = () => {
  const { t } = useTranslation();

  return useMemo(() => {
    return yup.object().shape<PasswordSubmitMethodFormFields>({
      method: yup
        .string()
        .oneOf(Object.values(PasswordSubmitMethod))
        .required(),
      workEmail: yup
        .string()
        .email(t('laValidEmail'))
        .when('method', (method, schema) => {
          return method === PasswordSubmitMethod.WorkEmail
            ? schema.required(t('laRequired'))
            : schema;
        }),
      mobile: yup
        .string()
        .when('method', (method, schema) => {
          return method === PasswordSubmitMethod.SMS
            ? schema.required(t('laRequired'))
            : schema;
        })
        .test(
          'phoneNumberValidation',
          t('phoneInvalid'),
          isValidOptionalPhoneNumber,
        ),
      alternateEmail: yup
        .string()
        .email(t('laValidEmail'))
        .when('method', (method, schema) => {
          return method === PasswordSubmitMethod.AlternateEmail
            ? schema.required(t('laRequired'))
            : schema;
        }),
    });
  }, [t]);
};
